import type { NotificationType } from '../components/NotificationContainer';

/**
 * Service for displaying toast notifications
 * Dispatches custom events that NotificationContainer listens to
 */
export const notificationService = {
    /**
     * Show a notification
     */
    show: (message: string, type: NotificationType = 'info') => {
        const event = new CustomEvent('app-notification', {
            detail: {
                message,
                type,
                timestamp: new Date().toISOString()
            }
        });
        window.dispatchEvent(event);
    },

    /**
     * Show an error notification
     */
    showError: (message: string) => {
        notificationService.show(message, 'error');
    },

    /**
     * Show a success notification
     */
    showSuccess: (message: string) => {
        notificationService.show(message, 'success');
    },

    /**
     * Show a warning notification
     */
    showWarning: (message: string) => {
        notificationService.show(message, 'warning');
    },

    /**
     * Show an info notification
     */
    showInfo: (message: string) => {
        notificationService.show(message, 'info');
    }
};

